export const defaultValues = [2, 4, 8, 12, 14, 16, 20, 24, 32, 40, 48, 64, 80, 96, 160]
export const STORAGE_NAME="rem-calculator-values"